import React, {useState} from "react";
import { subtractDays } from "../../functions/functions";
import axios from "axios";
import {setError} from "../../slices/error/ErrorSlice";
import { useDispatch } from "react-redux";
import Error from "../elements/Error";
import {ColorRing} from "react-loader-spinner";

export default function Report() {
    const dispatch = useDispatch();

    const [reExpParam, setReExpParam] = useState({
        date_from: subtractDays(new Date(), -2).toISOString().substring(0,10),
        date_to: new Date().toISOString().substring(0,10)
    })
    const [fssParam, setFssParam] = useState({
        date_from: subtractDays(new Date(), -2).toISOString().substring(0,10),
        date_to: new Date().toISOString().substring(0,10)
    })
    const [loader, setLoader] = useState(false);

    function changeReExpParam(e) {
        let name = e.target.name;
        setReExpParam({...reExpParam, [name]: e.target.value});
    }

    function changeFssParam(e) {
        let name = e.target.name;
        setFssParam({...fssParam, [name]: e.target.value});
    }

    const getReExpReport =  async () => {
        setLoader(true);

        await axios.post('/api/report/xls/re_exp', reExpParam, {
            responseType: "blob",
        })
            .then(result => {
                if (result.status === 200) {
                    console.log(result)
                    let contentDisposition = result.headers['content-disposition'];
                    let findFileArr = /".*"/.exec(contentDisposition);
                    let fileName = findFileArr[0].substring(1, findFileArr[0].length-1);

                    const element = document.createElement("a")
                    const blob = new Blob([result?.data])
                    element.href = URL.createObjectURL(blob)
                    element.download = fileName;
                    document.body.appendChild(element)
                    element.click()

                    element.parentNode.removeChild(element);

                    setLoader(false);
                } else {
                    console.log('error: ' + result )
                }
            })
            .catch(e => {
                dispatch(setError({detail: 'Ошибка запроса. Проверьте параметры или обратитесь к администратору.'}));
            })
    }

    const getFssReport = async () => {
        setLoader(true);

        await axios.post('/api/report/xls/fss', fssParam, {
            responseType: "blob",
        })
            .then(result => {
                if (result.status === 200) {
                    console.log(result)
                    let contentDisposition = result.headers['content-disposition'];
                    let findFileArr = /".*"/.exec(contentDisposition);
                    let fileName = findFileArr[0].substring(1, findFileArr[0].length-1);

                    const element = document.createElement("a")
                    const blob = new Blob([result?.data])
                    element.href = URL.createObjectURL(blob)
                    element.download = fileName;
                    document.body.appendChild(element)
                    element.click()

                    element.parentNode.removeChild(element);

                    setLoader(false);
                } else {
                    console.log('error: ' + result )
                }
            })
            .catch(e => {
                dispatch(setError({detail: 'Ошибка запроса. Проверьте параметры или обратитесь к администратору.'}));
            })
    }

    return (
        <>
            <Error/>
            <h1>Ежедневная выгрузка</h1>

            <ColorRing
                visible={loader}
                height="80"
                width="80"
                ariaLabel="color-ring-loading"
                wrapperStyle={{}}
                wrapperClass="color-ring-wrapper"
                colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
            />

            <div className='card bg-light shadow-sm p-2 block-day-upload'>
                <h4>Реэкспортные сертификаты</h4>
                <div className='row d-inline-flex mt-3'>
                    <div className="col-auto textOnInput align-top">
                        <label htmlFor="date_from">С</label>
                        <input className="form-control min-width-150" type="date" id="date_from"
                               name="date_from" value={reExpParam.date_from} onChange={changeReExpParam}
                        />
                    </div>
                    <div className="col-auto textOnInput align-top">
                        <label htmlFor="date_to">По</label>
                        <input className="form-control min-width-150" type="date" id="date_to" name="date_to"
                               value={reExpParam.date_to} onChange={changeReExpParam}
                        />
                    </div>
                    <div className='col-auto text-center'>
                        <input type='button' className='btn mb-0 btn-success' value='Выгрузить' onClick={getReExpReport}
                        />
                    </div>
                </div>
            </div>
            <div className='card bg-light shadow-sm p-2 block-day-upload mt-3'>
                <h4>Сертификаты по странам</h4>
                <div className='row d-inline-flex mt-3'>
                    <div className="col-auto textOnInput align-top">
                        <label htmlFor="date_from">С</label>
                        <input className="form-control min-width-150" type="date" id="date_from"
                               name="date_from" value={fssParam.date_from} onChange={changeFssParam}
                        />
                    </div>
                    <div className="col-auto textOnInput align-top">
                        <label htmlFor="date_to">По</label>
                        <input className="form-control min-width-150" type="date" id="date_to" name="date_to"
                               value={fssParam.date_to} onChange={changeFssParam}
                        />
                    </div>
                    <div className='col-auto text-center'>
                        <input type='button' className='btn mb-0 btn-success' value='Выгрузить' onClick={getFssReport}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}